import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import clevertap from 'clevertap-web-sdk';

// Initialize CleverTap with proper configuration
// clevertap.init('589-ZW8-947Z', 'eu1');
// clevertap.setLogLevel(3); // Optional: for debugging
// clevertap.privacy.push({optOut: false}) // Set the flag to true, if the user of the device opts out of sharing their data
// clevertap.privacy.push({useIP: false})  // Set the flag to true, if the user agrees to share their IP data
// clevertap.spa = true; // Enable Single Page Application mode

// console.log("CleverTap initialized, ID:", clevertap.getCleverTapID());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
